export default __webpack_public_path__ + "static/media/uses-background.04535e9f.mp4";